import { render, staticRenderFns } from "./FormKeyword.vue?vue&type=template&id=8a97d38c&"
import script from "./FormKeyword.vue?vue&type=script&lang=js&"
export * from "./FormKeyword.vue?vue&type=script&lang=js&"
import style0 from "./FormKeyword.vue?vue&type=style&index=0&id=8a97d38c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports